/* eslint-disable func-names */
import { DatePicker, Space } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import ArrowLineIcon from 'Components/common/assets/svgIcons/ArrowLineIcon';
import PersonMeetingIcon from 'Components/common/assets/svgIcons/PersonMeetingIcon';
import { DateRangePickerProps } from 'Types/GlobalTypes';
// import { Moment } from 'moment';

// interface DateRangePickerProps {
//   startDate: Moment
//   endDate: Moment
//   disabledEndDate: (val: Moment) => boolean
//   handleStartDateChange: (value: Moment | null) => void
//   handleEndDateChange: (val: Moment | null) => void
// }

const DateRangePicker = function ({
  startDate,
  endDate,
  disabledEndDate,
  handleStartDateChange,
  handleEndDateChange,
}: DateRangePickerProps) {
  return (
    <Space direction="horizontal" className="date-picker">
      <div>
        <DatePicker
          onChange={
            (date: Dayjs | null) => handleStartDateChange(date ? dayjs(date) : null)
          }
          value={startDate && dayjs.isDayjs(startDate) && startDate.isValid() ? startDate : null}
          placeholder="Start Date"
          suffixIcon={<PersonMeetingIcon />}
          popupClassName="date-picker-dropdown"
        />
      </div>
      <div><ArrowLineIcon color="#000" /></div>
      <DatePicker
        onChange={
          (date: Dayjs | null) => handleEndDateChange(date ? dayjs(date) : null)
        }
        value={endDate && dayjs.isDayjs(endDate) && endDate.isValid() ? dayjs(endDate) : null}
        placeholder="End Date"
        disabledDate={disabledEndDate}
        suffixIcon={<PersonMeetingIcon />}
        popupClassName="date-picker-dropdown"
      />
    </Space>
  );
};

export default DateRangePicker;
